/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontProductTile_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontProductGrid_viewer$ref: FragmentReference;
export type StorefrontProductGrid_viewer = {|
  +$fragmentRefs: StorefrontProductTile_viewer$ref,
  +$refType: StorefrontProductGrid_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontProductGrid_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontProductTile_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f1cf5bc5923dd762b08b8db854ff6678';
module.exports = node;
